import { Create, useNotify } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { RedirectedApiClientForm } from "./RedirectedApiClientForm";
import resourceNames from "../../../common/data/resourceNames";
import { useHistory } from "react-router-dom";

interface Props {}

export const RedirectedApiClientCreate = (props: Props) => {
  const history = useHistory();
  const notify = useNotify();
  const handleSuccess = () => {
    history.push(`/${resourceNames.ADMIN_API_CLIENTS}`);
    notify("resources.admin-api-clients.labels.createRedirectedApiSuccess", {
      type: "success",
    });
  };
  return (
    <Create
      {...props}
      actions={<EditActions />}
      onSuccess={handleSuccess}
      title="resources.admin-api-clients.title.create"
    >
      <RedirectedApiClientForm />
    </Create>
  );
};
